module.exports = __webpack_public_path__ + "media/images/icon__calendar-7bfbd0164a6e3db22b9a82f41b3328f7.png";